import { Query } from '@apollo/client/react/components';
import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';

import {
  MetricUpstreamDataQualityWarningsQuery,
  MetricUpstreamDataQualityWarningsQueryVariables
  ,
  MetricUpstreamDataQualityWarningsDocument
} from '../../../../../gen-src/queries';
import {
  GraphDataQualityWarning,
  VizPortalDQWDataCatalogProvider, WarningStatusChip, WarningStatusProps
} from '../../../data-catalog-shared';
import { ErrorListProvider } from '../error/components/ErrorListProvider';
import { RenderQueryResult } from '../renderQueryResult';
import { EmbeddableDataQualityWarningProps } from './EmbeddableDataQualityWarningProps';

type MetricWarningProps = {
  readonly metricLuid: string;
} & Pick<WarningStatusProps, 'side'>

export type EmbeddableMetricDataQualityWarningProps = EmbeddableDataQualityWarningProps & MetricWarningProps;

/** @deprecated TFS1478812 */
export function EmbeddableMetricDataQualityWarning(props: EmbeddableMetricDataQualityWarningProps): JSX.Element {
  const { source, siteUrls: urls } = props;

  return (
    <VizPortalDQWDataCatalogProvider {...props}>
      <ErrorListProvider>
        <Query<MetricUpstreamDataQualityWarningsQuery, MetricUpstreamDataQualityWarningsQueryVariables>
          query={MetricUpstreamDataQualityWarningsDocument}
          variables={{ metricLuid: props.metricLuid, first: 10, offset: 0 }}
        >
          {result => <RenderQueryResult result={result} renderers={{
            renderLoading: () => renderWarnings(urls, props.side, source, undefined),
            renderData: data => renderWarnings(urls, props.side, source, data),
          }} />}
        </Query>
      </ErrorListProvider>
    </VizPortalDQWDataCatalogProvider>
  );
}

const empty: GraphDataQualityWarning[] = [];

export function renderWarnings(
  urls: SiteUrls,
  side: WarningStatusProps['side'],
  source?: string,
  data?: MetricUpstreamDataQualityWarningsQuery
): JSX.Element | null {
  const metric = data && data.metrics ? data.metrics[0] : null;
  if (!metric) {
    return null;
  }

  const props: WarningStatusProps = {
    subjectArea: 'Metric',
    kind: 'graph',
    anchoredAsset: null,
    anchoredWarnings: [],
    iconOnly: false,
    side: side,
    urls,
    upstreamWarnings: metric.upstreamDataQualityWarningsConnection?.nodes ?? empty,
    source: source ?? 'EmbeddableMetricDataQualityWarning',
  }

  return <WarningStatusChip {...props} />;
}
